<svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.6 49.44"
    ><g id="Ebene_1-2"><path d="M0,0H11.76L29.16,38.88,46.08,0h11.52l-23.52,49.44h-10.2L0,0Z" /></g
    ></svg
>
